import { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { useDispatch } from "react-redux";
import swal from "@sweetalert/with-react";
import Card from "../../components/Card";
import TextInput from "../../components/TextInput";
import Button from "../../components/Button";
import { setInterface } from "../../redux/slices/interfaceSlice";
import service from "../../service";

export default function MetaCapi() {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState({ pixel_id: "", test_event_code: "", has_token: false });
  const [token, setToken] = useState("");

  const getData = () => {
    setLoading(true);
    service
      .get("/api/settings/capi")
      .then((res) => {
        setData(res.data);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  };

  const save = () => {
    const payload = { pixel_id: data.pixel_id, test_event_code: data.test_event_code };
    if (token) payload.access_token = token;
    (data.id ? service.put("/api/settings/capi", payload) : service.post("/api/settings/capi", payload))
      .then(() => {
        swal("Berhasil", "Meta CAPI settings disimpan", "success");
        setToken("");
        getData();
      })
      .catch(() => swal("Gagal", "Gagal menyimpan", "error"));
  };

  const remove = () => {
    service
      .delete("/api/settings/capi")
      .then(() => {
        setData({ pixel_id: "", test_event_code: "", has_token: false });
        setToken("");
        swal("Berhasil", "Token dihapus", "success");
      })
      .catch(() => swal("Gagal", "Gagal menghapus", "error"));
  };

  useEffect(() => {
    dispatch(
      setInterface({
        active: "Settings",
        pageTitle: "Meta CAPI Settings",
      })
    );
    getData();
  }, [dispatch]);

  if (loading) return <Card><div className="p-4">Memuat...</div></Card>;
  return (
    <Card>
      <Helmet><title>Meta CAPI Settings</title></Helmet>
      <div className="p-4 space-y-4 max-w-lg">
        <TextInput
          label="Pixel ID"
          placeholder="123456789"
          value={data.pixel_id}
          onChange={(e) => setData({ ...data, pixel_id: e.target.value })}
        />
        <TextInput
          label="Access Token"
          type="password"
          placeholder={data.has_token ? "Token tersimpan. Kosongkan jika tidak diubah." : "Masukkan token"}
          value={token}
          onChange={(e) => setToken(e.target.value)}
        />
        <TextInput
          label="Test Event Code (opsional)"
          placeholder="TEST12345"
          value={data.test_event_code || ""}
          onChange={(e) => setData({ ...data, test_event_code: e.target.value })}
        />
        <div className="flex gap-2">
          <Button onClick={save}>Simpan</Button>
          {data.has_token && <Button color="red" onClick={remove}>Hapus Token</Button>}
        </div>
      </div>
    </Card>
  );
}